/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { Field, useForm } from 'react-final-form';
import { Col, MultiSelection, Row } from '@folio/stripes-components';
import { useFieldArray } from 'react-final-form-arrays';
import useDataByName from '../../../../../../../hooks/useDataByName';
import styles from '../../styles.css';
import ToggleButton from '../../../../../../FormFieldsGenerator/components/ToggleButton';

const propTypes = {
  fieldName: PropTypes.string,
  fieldData: PropTypes.object,
  index: PropTypes.number,
  fields: PropTypes.object,
};

function AvailableLists({ fieldName, fields, fieldData, index }) {
  const data = useDataByName(fieldData?.dataOptionsSource);
  const form = useForm();
  const drivedFields = useFieldArray('drivedFieldsValues');
  const availableLists = useFieldArray('availableLists');

  const options = [];
  (data || []).forEach((opt) => {
    options.push({
      value: opt.id,
      label: opt.name,
      name: opt.name,
    });
  });

  const { label } = fieldData;
  const { locale, formatMessage } = useIntl();
  const fieldLabel = label?.find((field) => field?.locale === locale)?.value;
  const isPrimary = fields.value[index].isPrimary;

  const onAddListItem = (item) => {
    drivedFields.fields.push({
      value: item.value,
      name: item.label,
      isRepeatable: false,
      isRequired: false,
      canEdit: true,
    });
  };

  const onRemoveListItem = (item) => {
    const itemIndex = drivedFields.fields.value?.findIndex(
      (field) => field.value === item.value,
    );

    drivedFields.fields.remove(itemIndex);
  };

  const onCahngePrimaryList = () => {
    form.change('drivedFieldsValues', []);
    return availableLists.fields?.value.map((field, idx) =>
      form.change(`availableLists[${idx}].selectedValues`, []),
    );
  };

  const listFormatter = ({ option }) => {
    return (
      <div key={option.value}>
        {formatMessage({
          id: `ui-inventory.${
            fieldData.dataOptionsSource
          }.name.${option.name}`,
          defaultMessage: option.name,
        })}
      </div>
    );
  };

  return (
    <Row>
      <Col xs={10}>
        <Field
          id={`${fieldName}.selectedValues`}
          name={`${fieldName}.selectedValues`}
          type="text"
          component={MultiSelection}
          dataOptions={options}
          formatter={listFormatter}
          onAdd={(item) => onAddListItem(item)}
          onRemove={(item) => onRemoveListItem(item)}
          fullWidth
          label={fieldLabel}
          disabled={!isPrimary}
          required={isPrimary}
        />
      </Col>
      {fields.length > 1 && (
        <Col xs={2} className={styles.driveBtn}>
          <ToggleButton
            fieldValues={fieldData}
            fields={fields}
            index={index}
            fieldname="isPrimary"
            noLabel
            fullWidth={false}
            buttonLabel={
              <FormattedMessage
                id="ui-plugin-inventory-templates.driveNewFieldsModal.driveBtn.label"
                defaultMessage="Drive here"
              />
            }
            onChange={onCahngePrimaryList}
            disabled={isPrimary}
          />
        </Col>
      )}
    </Row>
  );
}

AvailableLists.propTypes = propTypes;

export default AvailableLists;
